import { useDailyLoginStreak } from '../hooks/useDailyLoginStreak';

/**
 * Headless, app-wide tracker that keeps the user's login streak alive whether
 * they log in fresh each day or stay logged in and revisit. Renders nothing;
 * mount once inside the authenticated layout.
 */
const DailyLoginTracker = (): null => {
	useDailyLoginStreak();
	return null;
};

export default DailyLoginTracker;
